import { Container } from "@mui/material";

export default function ContentLayout({ children }) {
  return (
    <Container
      maxWidth={false}
      sx={{
        width: "70vw",
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {children}
    </Container>
  );
}
